// Cloudflare Turnstile site key used by the sign-in and sign-up flows.
// Mirrors the key configured on the marketing site's WordPress sign-up page.
// Overridable per-environment via VUE_APP_TURNSTILE_SITE_KEY.
export const TURNSTILE_SITE_KEY =
	process.env.VUE_APP_TURNSTILE_SITE_KEY || '0x4AAAAAAB6o1_uGcD_HhuOO'
